export interface ApplicationTypeDetails {
  name: string;
  image: string;
  code: string;
  feesCode?: string;
  description: string;
  customerType: string;
}
